import { useQuery } from '@tanstack/react-query';
import { listProfiles } from './api';
import { useApiContext } from '../../contexts/FileDeliveryContext';
import type { Profile } from './types';

export const useProfilesQuery = () => {
  const apiContext = useApiContext();

  return useQuery<Profile[]>({
    queryKey: ['profiles', apiContext.datacenter],
    queryFn: () => listProfiles({ ...apiContext, serviceAccount: 'epadmin' }),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: !!apiContext.datacenter,
  });
};
